import { callKarrotBridgeSafely } from '../lib/karrot_bridge_utils'

const SAME_WEBVIEW_PATHS = ['/wv/feedbacks']

const isInSameWebviewPath = (href) => SAME_WEBVIEW_PATHS.some((path) => href.includes(path))

const isExplicitlyMarkedSameWebview = (link) => link.dataset.sameWebview === 'true'

const shouldInterceptAsExternalLink = (link) => {
  if (!link) return false
  if (link.href.startsWith('mailto:')) return false
  const appScheme = window.config?.app_scheme
  if (typeof appScheme === 'string' && appScheme.length > 0 && link.href.startsWith(appScheme)) {
    return false
  }
  return true
}

const openInNewRouter = (href) => {
  const controllersWithNavbar = Array.isArray(window.controllersWithNavbar)
    ? window.controllersWithNavbar
    : []
  const hideNavbar = controllersWithNavbar.some((controller) => href.includes(controller))

  return callKarrotBridgeSafely((bridge) => {
    bridge.pushRouter({ router: { remote: href, navbar: !hideNavbar } })
    bridge.emitToStream({ stream: { eventName: 'router:push', data: JSON.stringify({ link: href }) } })
  })
}

document.addEventListener('click', (e) => {
  // 화면 쪽 핸들러가 이미 막은 클릭(예: 로그인 필수 카테고리의 로그인 모달)은 새 router 로 열지 않는다
  if (e.defaultPrevented) return
  const link = e.target.closest('a')
  if (!shouldInterceptAsExternalLink(link)) return
  if (isExplicitlyMarkedSameWebview(link)) return
  if (isInSameWebviewPath(link.href)) return

  const handled = openInNewRouter(link.href)
  if (handled) e.preventDefault()
})
